import { useEffect, useState } from "react";
import Banner from "../utilities/Banner/Banner";
import BundleGrid from "./BundleGrid";
import { Constants, GridConstants } from "./Content";
import { Box, Typography } from "@mui/material";
import { LocalStorageKeys, UserRole } from "../QuoteRequest/Content";
import { isJsonString } from "../../Helper/Helper";
import { useDispatch } from "react-redux";
import {
  getAllBundles,
  getOpportunityByUser,
  getPendingApprovalRolesForBundle,
  getSAMLeadership,
} from "../../Actions/QuoteAction";
import { Congiguration } from "../../Constants/AppConstants";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import SearchInput from "../utilities/SearchInput/SearchInput";
import FormControl from "@mui/material/FormControl";
import { ManageBundleWrapper } from "./ManageBundlesStyled";
import Notification from "../utilities/Notification/Notification";
import { getCRMDataDetails } from "../../Actions/CRMAction";
import { getDecryptedText } from "../../Actions/CommonAction";
import { getLoggedUserDetails } from "../../Actions/UserAction";
import {
  SetLoggedInUserDataInSession,
  SetCRMDataInSession,
} from "../../Helper/SessionHelper";

import { useNavigate } from "react-router-dom";

const ManageBundles = () => {
  const dispatch = useDispatch();
  //added by Subbu
  let search = window.location.search;
  let params = new URLSearchParams(search);
  console.log("This is params " + params);
  //end
  const navigate = useNavigate();

  let loggedUser = isJsonString(
    sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER),
  )
    ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER))
    : null;

  const bundleGridHeaderCells = [
    { id: "bundleName", label: "Bundle Name", sm: 1 },
    { id: "bundleDiscount", label: "Discount", sm: 1 },
    { id: "createdBy", label: "Created By", sm: 2 },
    { id: "createdDate", label: "Created Date", sm: 2 },
    //{ id: 'totalHeadCount', label: 'Head Count', },
    { id: "bundleProducts", label: "Products", sm: 2 },
    { id: "totalRevenueIncComUSD", label: "Total Revenue", sm: 1 },
    { id: "statusName", label: "Bundle Status", sm: 1 },
    { id: "notes", label: "Notes", sm: 1 },
    { id: "refresh", label: "", sm: 1 },
  ];

  const bundleAccordianHeaders = [
    { id: "bundleName", label: "Bundle Name" },
    { id: "bundleDiscount", label: "Discount" },
    { id: "createdBy", label: "Created By" },
    { id: "createdDate", label: "Created Date" },
    { id: "totalHeadCount", label: "Head Count" },
    { id: "bundleProducts", label: "Products" },
    { id: "totalRevenueIncComUSD", label: "Total Revenue" },
    { id: "statusName", label: "Bundle Status" },
    { id: "notes", label: "Notes" },
    { id: "refresh", label: "Refresh" },
  ];

  const [pageNumber, setPageNumber] = useState(GridConstants.INITALPAGENO);
  const [allBundlesRawData, setAllBundlesRawData] = useState([]);
  const [bundledQuotes, setBundledQuotes] = useState([]);
  const [allbundledQuotes, setAllBundledQuotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [bundleLoading, setBundleLoading] = useState(false);
  const [isMyRequests, setIsMyRequests] = useState(false);
  const [searchText, setsearchText] = useState("");
  const [searchSelectedOpportunity, setSearchSelectedOpportunity] = useState({
    oppurtunityId: "0",
    oppurtunity: "All",
    oppurtunityName: "All",
  });
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [opportunity, setOpportunity] = useState({});
  const [opportunityList, setOpportunityList] = useState([]);
  const [showAlertNotification, setShowAlertNotification] = useState(false);
  const [alertDialogMessage, setAlertDialogMessage] = useState("");
  const [alertDialogSeverity, setAlertDialogSeverity] = useState("");
  const [samLeadershipData, setSamLeadershipData] = useState([]);
  const [loadingState, setLoadingState] = useState(true); //added by Subbu
  const [pendingApproverRoles, setPendingApproverRoles] = useState([]);
  //To handle change in "isMyRequests" variable
  useEffect(() => {
    if (isMyRequests) {
      const currentBundlesList = [...allbundledQuotes];
      setPageNumber(GridConstants.INITALPAGENO);
      const filteredBundles = [
        ...currentBundlesList.filter(
          (bundleQuotes) =>
            bundleQuotes[0]?.bundleDetails?.createdById ===
            loggedUser?.user?.id,
        ),
      ];
      setBundledQuotes(filteredBundles);
    } else {
      setBundledQuotes([]);
      setPageNumber(GridConstants.INITALPAGENO);
      setBundledQuotes([...allbundledQuotes]);
    }
  }, [isMyRequests]);

  useEffect(() => {
    document.title = "Manage Bundles";
    //added If condition
    if (search) {
      const encrParam = search.replace("?", "");
      console.log(encrParam);
      getDecryptedParamValues(encrParam);
    } else {
      getAllBundlesList();
      getOppurtintyList(selectedOpportunity, loggedUser?.user?.id);
      getOpportunityDetails(selectedOpportunity);
    }
    getSamLeaderShipList();
  }, []);

  const filterMyRequests = () => {
    const currValue = isMyRequests;
    if (currValue) {
      setIsMyRequests(false);
    } else {
      setIsMyRequests(true);
    }
  };

  const handleChangeSearch = (text) => {
    setsearchText(text);
    setPageNumber(GridConstants.INITALPAGENO);
  };

  //added by Subbu

  const getAllBundlesList = (opportunityId, userId = null) => {
    const currentWorkingOpportunityId = sessionStorage.getItem(
      LocalStorageKeys.CURRENTWORKINGOPPORTUNITY,
    );
    const oppId = opportunityId ? opportunityId : currentWorkingOpportunityId;
    setLoading(true);
    setBundleLoading(true);
    dispatch(getAllBundles(oppId, loggedUser?.user?.id ?? userId))
      .then((res) => {
        setAllBundlesRawData(...[res]);
        setBundleDetails(res);
        setBundleLoading(false);
        setLoading(false);
      })
      .catch((e) => {
        setBundleLoading(false);
        setLoading(false);
        console.log(e);
      });
  };

  function getDecryptedParamValues(params) {
    setLoadingState(true);
    dispatch(getDecryptedText(params))
      .then((decrParam) => {
        console.log("decrParam", decrParam);
        params = new URLSearchParams("?" + decrParam);
        let oppurtunityid = params.get("OpportunityId");
        let email = params.get("UserEmail");

        //setting email and opp id in localStorage to handle page refresh
        if (
          !sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID) ||
          (sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID) == null &&
            sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID) == "null") ||
          sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID) !=
            oppurtunityid
        ) {
          sessionStorage.setItem(LocalStorageKeys.OPPORTUNITYID, oppurtunityid);
        }
        getAndSetLoggedUser(email, oppurtunityid);
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
      });
  }

  function getAndSetLoggedUser(useremail, oppurtunityid) {
    useremail = useremail ?? loggedUser?.user?.email;
    if (useremail && useremail !== "") {
      sessionStorage.setItem(LocalStorageKeys.USEREMAIL, useremail);
      setLoadingState(true);
      dispatch(getLoggedUserDetails(useremail))
        .then((userData) => {
          console.log("userData", userData);
          SetLoggedInUserDataInSession(userData);
          getAllBundlesList(oppurtunityid, userData?.user?.id);

          getOpportunityDetails(oppurtunityid).then((res) => {
            getOppurtintyList(oppurtunityid, userData?.user?.id);
          });

          if (
            !userData ||
            userData.user === null ||
            userData.user === "null" ||
            !userData.user.isActive
          ) {
            sessionStorage.clear();
            localStorage.clear();

            navigate("/pageNotfound", {
              state: {
                status: Congiguration.unauthorizedStatus,
              },
            });
            return false;
          }
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
          setLoading(false);
        });
    }
  }

  const setBundleDetails = (allBundles) => {
    const bundleOpportunityDetailsMap = new Map();

    allBundles?.opportunityBundleDetails.forEach((obj) => {
      if (!bundleOpportunityDetailsMap.has(obj.bundleId))
        bundleOpportunityDetailsMap.set(obj.bundleId, []);
      bundleOpportunityDetailsMap.get(obj.bundleId).push(obj);
    });

    const bundleQuotesMap = new Map();

    allBundles?.bundledQuotes.forEach((obj) => {
      if (!bundleQuotesMap.has(obj.bundleId))
        bundleQuotesMap.set(obj.bundleId, []);
      bundleQuotesMap.get(obj.bundleId).push(obj);
    });

    const bundleNotesMap = new Map();

    allBundles?.bundleNotes.forEach((obj) => {
      if (!bundleNotesMap.has(obj.bundleId))
        bundleNotesMap.set(obj.bundleId, []);
      bundleNotesMap.get(obj.bundleId).push(obj);
    });
    const bundleArray = [];

    bundleQuotesMap.forEach((array) => {
      let rateSum = array.reduce(
        (accumulator, currentValue) =>
          accumulator + currentValue?.rateReqCurrency,
        0,
      );

      let rateSumUsd = array.reduce(
        (accumulator, currentValue) => accumulator + currentValue?.rateUSD,
        0,
      );

      const bundleOpportunityDetails = bundleOpportunityDetailsMap.get(
        array[0].bundleId,
      );
      const bundleNotes = bundleNotesMap.get(array[0].bundleId);

      const bundleDetails = {
        bundleId: bundleOpportunityDetails[0].bundleId,
        bundleNameOnly: bundleOpportunityDetails[0].bundleName,
        bundleName: bundleOpportunityDetails[0].bundleNameByUser
          ? bundleOpportunityDetails[0].bundleName +
            "-" +
            bundleOpportunityDetails[0].bundleNameByUser
          : bundleOpportunityDetails[0].bundleName,
        bundleNameByUser: bundleOpportunityDetails[0].bundleNameByUser,
        bundleDiscount: bundleOpportunityDetails[0].bundleDiscount,
        createdBy:
          bundleOpportunityDetails[0].firstName +
          " " +
          bundleOpportunityDetails[0].lastName,
        createdById: bundleOpportunityDetails[0].createdBy,
        createdDate: bundleOpportunityDetails[0].createdDate,
        bundleProducts: bundleOpportunityDetails[0].bundleProducts,
        totalRevenueIncCom: bundleOpportunityDetails[0].totalRevenueIncCom,
        statusName: bundleOpportunityDetails[0].statusName,
        notes: bundleNotes ? bundleNotes : null,
        pendingApproverRoles: bundleOpportunityDetails[0].pendingApproverRoles,
        approvalAssignments: bundleOpportunityDetails[0].approvalAssignments,
      };
      const bundleRevenue = {
        totalRevenueIncCom: bundleOpportunityDetails[0].totalRevenueIncCom,
        totalRevenueIncComUSD:
          bundleOpportunityDetails[0].totalRevenueIncComUSD,
        annualRevenueWOCom: bundleOpportunityDetails[0].annualRevenueWOCom,
        annualRevenueWOComUSD:
          bundleOpportunityDetails[0].annualRevenueWOComUSD,
      };
      const opportunityDetails = {
        oppurtunity: bundleOpportunityDetails[0].oppurtunity,
        oppurtunityName: bundleOpportunityDetails[0].oppurtunityName,
        oppurtunityType: bundleOpportunityDetails[0].oppurtunityType,
        brokerName: bundleOpportunityDetails[0].brokerName,
        brokerCommission: bundleOpportunityDetails[0].brokerCommission,
        accountSubType: bundleOpportunityDetails[0].accountSubType,
        accountOwner: bundleOpportunityDetails[0].accountOwner,
        memberOf: bundleOpportunityDetails[0].memberOf,
      };
      array.map((quote) => {
        quote.displayOrderId = bundleOpportunityDetails[0].id;
        quote.rateReqCurrencySum = rateSum;
        quote.rateUsdSum = rateSumUsd;
        quote.bundleDetails = bundleDetails;
        quote.bundleRevenue = bundleRevenue;
        quote.opportunityDetails = opportunityDetails;
        quote.canSubmit = bundleOpportunityDetails[0].canSubmit;
        quote.canReject = bundleOpportunityDetails[0].canReject;
        quote.canNotify = bundleOpportunityDetails[0].canNotify;
      });
      bundleArray.push(array);
    });
    bundleArray.sort((a, b) => a[0]?.displayOrderId - b[0]?.displayOrderId);
    setBundledQuotes(...[bundleArray]);
    setAllBundledQuotes(...[bundleArray]);
  };

  const getOppurtintyList = (opportunityId, userId) => {
    setLoading(true);
    dispatch(getOpportunityByUser(userId))
      .then((data) => {
        let oppList = data.map(
          ({ oppurtunityId, oppurtunity, oppurtunityName }) => ({
            oppurtunityId,
            oppurtunity,
            oppurtunityName,
          }),
        );

        const allObj = {
          oppurtunityId: "0",
          oppurtunity: "All",
          oppurtunityName: "All",
        };
        const crmData = isJsonString(
          sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL),
        )
          ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL))
          : "";
        const currentOpportunity = {
          oppurtunityId: crmData.opportunityId ?? opportunity?.opportunityId,
          oppurtunity: crmData.opportunity ?? opportunity?.opportunity,
          oppurtunityName:
            crmData.opportunityName ?? opportunity?.opportunityName,
        };
        setSearchSelectedOpportunity(currentOpportunity);
        setOpportunityList([allObj, ...oppList]);

        if (!opportunityId || opportunityId === null) {
          opportunityId = sessionStorage.getItem(
            LocalStorageKeys.CURRENTWORKINGOPPORTUNITY,
          );
        }
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  const getOpportunityDetails = async (opportunityId) => {
    let oppId = null;

    if (opportunityId && opportunityId !== null) {
      oppId = opportunityId;
    } else {
      oppId = sessionStorage.getItem(
        LocalStorageKeys.CURRENTWORKINGOPPORTUNITY,
      );
    }
    if (oppId && oppId !== null && oppId !== "0" && oppId !== 0) {
      setLoading(true);
      await dispatch(getCRMDataDetails(oppId))
        .then((data) => {
          setOpportunity({ ...data });
          SetCRMDataInSession(data, oppId);
          const currentOpportunity = {
            oppurtunityId: data?.opportunityId,
            oppurtunity: data?.opportunity,
            oppurtunityName: data?.opportunityName,
          };
          console.log("OppList", opportunityList);
          setSearchSelectedOpportunity(currentOpportunity);
          setLoading(false);
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
        });
    }
    setSelectedOpportunity(oppId);
  };

  const getSamLeaderShipList = () => {
    dispatch(getSAMLeadership(UserRole.SAMLEADERSHIPTEAM))
      .then((data) => {
        setSamLeadershipData([...data]);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleOpportunityChange = (event, value) => {
    setOpportunity({});
    if (value) {
      sessionStorage.setItem(
        LocalStorageKeys.CURRENTWORKINGOPPORTUNITY,
        value?.oppurtunityId,
      );
      setSearchSelectedOpportunity(value);
      setSelectedOpportunity(value?.oppurtunityId);
      setPageNumber(GridConstants.INITALPAGENO);
      getAllBundlesList(value?.oppurtunityId);
      getOpportunityDetails(value?.oppurtunityId);
    } else {
      return false;
    }
  };

  const showNotification = (severity, message) => {
    setShowAlertNotification(true);
    setAlertDialogMessage(message);
    setAlertDialogSeverity(severity);
  };

  const closeShowAlertNotificationPopUp = () => {
    setShowAlertNotification(false);
    setAlertDialogMessage("");
    setAlertDialogSeverity("");
  };

  const updateBundleByIndex = (data, bundleId) => {
  let rateSum = data?.quotesForBundleDatas.reduce(
    (accumulator, currentValue) =>
      accumulator + (currentValue?.rateReqCurrency || 0),
    0,
  );

  let rateSumUsd = data?.quotesForBundleDatas.reduce(
    (accumulator, currentValue) =>
      accumulator + (currentValue?.rateUSD || 0),
    0,
  );

  let existingBundleArray = [...bundledQuotes];

  let bundleObj = existingBundleArray.find(
    (b) => b[0]?.bundleDetails?.bundleId === bundleId,
  );

  let bundleObjIndex = existingBundleArray.findIndex(
    (b) => b[0]?.bundleDetails?.bundleId === bundleId,
  );

  const bundleName = data?.bundleDetails?.bundleNameByUser
    ? data?.bundleDetails?.bundleName +
      "-" +
      data?.bundleDetails?.bundleNameByUser
    : data?.bundleDetails?.bundleName;

  const createdByName =
    data?.bundleDetails?.firstName + " " + data?.bundleDetails?.lastName;

  const bundleDetails = {
    ...(bundleObj?.[0]?.bundleDetails || {}),
    ...(data?.bundleDetails || {}),
    bundleNameOnly: data?.bundleDetails?.bundleName,
    bundleName: bundleName,
    totalRevenueIncCom: data?.quotesForBundleRevenueDatas?.[0]?.totalRevenueIncCom,
    createdBy: createdByName,
  };

  if (bundleObj) {
    let existingQuoteMap = new Map(
      bundleObj.map((q) => [q.quoteId, q]),
    );

    let updatedBundleObj = (data?.quotesForBundleDatas || []).map((quote) => {
      let quoteObj = existingQuoteMap.get(quote.quoteId);

      return {
        ...(quoteObj || {}),
        quoteId: quote.quoteId,
        productName: quote.productName,
        quoteName: quote.quoteName,
        pricingStructureName: quote.pricingStructureName,
        productVariationName: quote.productVariationName,
        currencyCode: quote.currencyCode,
        sessions: quote.sessions,
        utilization: quote.utilization,
        hours: quote.hours,
        headCount: quote.headCount,
        rateReqCurrency: quote.rateReqCurrency,
        rateUSD: quote.rateUSD,
        quoteStatusId: quote.quoteStatusId,
        statusName: quote.statusName,
        tcvcad: quote.tcvcad,
        totalTcvCad: data?.quotesForBundleRevenueDatas?.[0]?.tcvcad,
        rateReqCurrencySum: rateSum,
        rateUsdSum: rateSumUsd,
        canNotify: data?.bundleDetails?.canNotify,
        bundleDetails: bundleDetails,
        bundleRevenue: data?.quotesForBundleRevenueDatas?.[0],
      };
    });

    existingBundleArray.splice(bundleObjIndex, 1, updatedBundleObj);
  }

  setBundledQuotes(existingBundleArray);
};

  const getPendingApprovalRoles = (bundleId, statusId) => {
    dispatch(getPendingApprovalRolesForBundle(bundleId, statusId)).then(
      (response) => {
        setPendingApproverRoles(response);
      },
    );
  };

  const removeBundleById = (bundleId) => {
    let existingBundleArray = [...bundledQuotes];

    let bundleObj = existingBundleArray.find(
      (b) => b[0]?.bundleDetails?.bundleId === bundleId,
    );
    let bundleObjIndex = existingBundleArray.findIndex(
      (b) => b[0]?.bundleDetails?.bundleId === bundleId,
    );

    if (bundleObj && bundleObjIndex > -1) {
      existingBundleArray.splice(bundleObjIndex, 1);
    }

    setBundledQuotes(existingBundleArray);
  };

  const prepareAndUpdateBundleObject = (data, bundleId) => {
    const opportunityDetails = {
      oppurtunity: data.opportunityBundleDetails.oppurtunity,
      oppurtunityName: data.opportunityBundleDetails.oppurtunityName,
      oppurtunityType: data.opportunityBundleDetails.oppurtunityType,
      brokerName: data.opportunityBundleDetails.brokerName,
      brokerCommission: data.opportunityBundleDetails.brokerCommission,
      accountSubType: data.opportunityBundleDetails.accountSubType,
      accountOwner: data.opportunityBundleDetails.accountOwner,
      memberOf: data.opportunityBundleDetails.memberOf,
    };
    const bundleRevenue = {
      totalRevenueIncCom: data.opportunityBundleDetails.totalRevenueIncCom,
      totalRevenueIncComUSD:
        data.opportunityBundleDetails.totalRevenueIncComUSD,
      annualRevenueWOCom: data.opportunityBundleDetails.annualRevenueWOCom,
      annualRevenueWOComUSD:
        data.opportunityBundleDetails.annualRevenueWOComUSD,
    };
    const bundleDetails = {
      bundleId: data.opportunityBundleDetails.bundleId,
      bundleName: data.opportunityBundleDetails.bundleNameByUser
        ? data.opportunityBundleDetails.bundleName +
          "-" +
          data.opportunityBundleDetails.bundleNameByUser
        : data.opportunityBundleDetails.bundleName,
      bundleNameByUser: data.opportunityBundleDetails.bundleNameByUser,
      bundleDiscount: data.opportunityBundleDetails.bundleDiscount,
      createdBy:
        data.opportunityBundleDetails.firstName +
        " " +
        data.opportunityBundleDetails.lastName,
      createdDate: data.opportunityBundleDetails.createdDate,
      bundleProducts: data.opportunityBundleDetails.bundleProducts,
      totalRevenueIncCom: data.opportunityBundleDetails.totalRevenueIncCom,
      statusName: data.opportunityBundleDetails.statusName,
      notes: data.bundleNotes ? data.bundleNotes : null,
    };
    const bundleQuotes = [];

    let rateSum = data.bundledQuotes.reduce(
      (accumulator, currentValue) =>
        accumulator + currentValue?.rateReqCurrency,
      0,
    );
    let rateSumUsd = data.bundledQuotes.reduce(
      (accumulator, currentValue) => accumulator + currentValue?.rateUSD,
      0,
    );

    data.bundledQuotes.map((quote) => {
      quote.opportunityDetails = opportunityDetails;
      quote.rateReqCurrencySum = rateSum;
      quote.rateUsdSum = rateSumUsd;
      quote.bundleDetails = bundleDetails;
      quote.bundleRevenue = bundleRevenue;
      quote.canSubmit = data.opportunityBundleDetails.canSubmit;
      quote.canReject = data.opportunityBundleDetails.canReject;
      quote.canNotify = data.opportunityBundleDetails.canNotify;

      bundleQuotes.push(quote);
    });

    let existingBundleArray = [...bundledQuotes];

    let bundleObj = existingBundleArray.find(
      (b) => b[0]?.bundleDetails?.bundleId === bundleId,
    );
    let bundleObjIndex = existingBundleArray.findIndex(
      (b) => b[0]?.bundleDetails?.bundleId === bundleId,
    );

    if (bundleObj) {
      bundleObj = [];
      bundleObj = bundleQuotes;
      existingBundleArray.splice(bundleObjIndex, 1, bundleObj);
    }
    setBundledQuotes(existingBundleArray);
  };

  return (
    <Box sx={{ bgcolor: "#EFF6FF", width: "100%" }}>
      <ManageBundleWrapper>
        <Banner
          Heading={Constants.ManageBundleHeading}
          Paragraph={Constants.ManageBundleDescription}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            minHeight: "100vh",
            width: "100%",
            position: "absolute",
          }}
        >
          <Box
            sx={{
              width: "92%",
              padding: "0 15px",
              bgcolor: "#fff",
              borderRadius: "8px",
            }}
          >
            <div
              className="tableHeaderRight d-flex"
              style={{ marginTop: "0px" }}
            >
              <Box
                sx={{ m: 1, position: "relative", alignItems: "center" }}
                className="buttonBox"
              >
                <Typography variant="h4">{Constants.ManageBundles}</Typography>
                <div className="myRequestContainer">
                  <FormControlLabel
                    className={
                      isMyRequests ? "btnMyRequest-active" : "btnMyRequest"
                    }
                    control={
                      <Switch
                        checked={isMyRequests}
                        onChange={filterMyRequests}
                        name="myrequests"
                      />
                    }
                    label="My created requests"
                  />
                </div>
              </Box>
            </div>

            <Box
              sx={{ width: "100%", paddingBottom: 0, justifyContent: "center" }}
            >
              <div
                className="searchAndDropdownContainer"
                style={{
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "7px",
                }}
              >
                <Box
                  sx={{
                    flexGrow: 1,
                    minWidth: "200px",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <SearchInput
                    placeholder="Search"
                    onSearchChange={handleChangeSearch}
                    style={{
                      color: "#fff",
                      fontWeight: "bold",
                      padding: "8px",
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "nowrap",
                    gap: 2,
                    flexShrink: 0,
                    justifyContent: "flex-end",
                    width: "auto",
                  }}
                >
                  {selectedOpportunity !== 0 && selectedOpportunity !== "0" && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }}
                      >
                        <Typography
                          variant="h5"
                          sx={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          {GridConstants.ACCOUNT_NAME}
                          {opportunity.account ? (
                            <span style={{ fontWeight: "normal" }}>
                              {" "}
                              {opportunity.account}
                            </span>
                          ) : (
                            <CircularProgress size="15px" />
                          )}
                        </Typography>
                      </Box>

                      <Box sx={{ display: "inline", color: "#1b4a83", px: 2 }}>
                        |
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }}
                      >
                        <Typography
                          variant="h5"
                          sx={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          {GridConstants.OPP_NAME}
                          {opportunity.opportunityName ? (
                            <span style={{ fontWeight: "normal" }}>
                              {" "}
                              {opportunity.opportunityName}
                            </span>
                          ) : (
                            <CircularProgress size="15px" />
                          )}
                        </Typography>
                      </Box>

                      <Box sx={{ display: "inline", color: "#1b4a83", px: 2 }}>
                        |
                      </Box>
                    </Box>
                  )}

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 1,
                      minWidth: "200px",
                      paddingRight: 1,
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        textAlign: "center",
                        marginRight: 2,
                      }}
                    >
                      {GridConstants.OPP_ID}
                    </Typography>

                    <FormControl sx={{ flex: 1 }}>
                      <Autocomplete
                        size="small"
                        placeholder="Select"
                        sx={{
                          width: "100%",
                          minWidth: "170px",
                        }}
                        options={opportunityList}
                        getOptionLabel={(option) => option.oppurtunity}
                        value={searchSelectedOpportunity}
                        onChange={handleOpportunityChange}
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            {...params}
                            variant="outlined"
                          />
                        )}
                      />
                    </FormControl>
                  </Box>
                </Box>
              </div>
            </Box>
            <Box
              className="tableSection"
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <BundleGrid
                headerCells={bundleGridHeaderCells}
                quotesLoading={false}
                searchText={searchText}
                loggedUser={loggedUser}
                bundledQuotes={bundledQuotes}
                showNotification={showNotification}
                updateBundleByIndex={updateBundleByIndex}
                prepareAndUpdateBundleObject={prepareAndUpdateBundleObject}
                bundlesLoading={bundleLoading}
                removeBundleFromList={removeBundleById}
                samLeadershipData={samLeadershipData}
              />
            </Box>
          </Box>
        </Box>

        {loading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        {showAlertNotification && (
          <Notification
            open={showAlertNotification}
            onClose={closeShowAlertNotificationPopUp}
            message={alertDialogMessage}
            severity={alertDialogSeverity}
          />
        )}
      </ManageBundleWrapper>
    </Box>
  );
};

export default ManageBundles;
